export default "__VITE_ASSET__CdZ6YHwa__"